import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <motion.footer
      className="py-4 text-center border-t backdrop-blur-xl"
      style={{
        background: 'rgba(11, 18, 32, 0.5)',
        borderColor: 'rgba(var(--line), 0.4)'
      }}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.5, duration: 0.5 }}
    >
      <div className="flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 mb-2">
        <Link
          to="/terms"
          className="text-xs sm:text-sm hover:underline transition-colors"
          style={{ color: 'var(--accent-ocean)' }}
        >
          Conditions d'utilisation
        </Link>
        <span className="hidden sm:inline text-xs" style={{ color: 'var(--text-muted)' }}>•</span>
        <Link
          to="/privacy"
          className="text-xs sm:text-sm hover:underline transition-colors"
          style={{ color: 'var(--accent-ocean)' }}
        >
          Politique de confidentialité
        </Link>
      </div>
      <p className="text-xs sm:text-sm" style={{ color: 'var(--text-muted)' }}>
        © 2026 OpenMeta. Tous droits réservés.
      </p>
    </motion.footer>
  );
};

export default Footer;
